import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { GetGroups$Params } from 'src/api/generated/fn/group/get-groups';
import { RemoveGroup$Params } from 'src/api/generated/fn/group/remove-group';
import { GroupDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Group/group-dto';
import { GroupService } from 'src/api/generated/services';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit, OnDestroy {

  public groups: Array<GroupDto>;
  venueId: string;
  venueIdUpdateSubscription: Subscription;
  loading: boolean = true;
  
  public searchTerm: string = '';
  searchDebouncer = new Subject<void>();
  RELOAD_DEBOUNCE_TIME = 500;

  constructor(private groupService: GroupService,
              private route: ActivatedRoute,
              private router: Router,
              public currentVenueHelper: CurrentVenueHelperService,
              private confirmationService: ConfirmationService,
              private translate: TranslateService) {
      
    }

  ngOnInit(): void {
    this.searchDebouncer.pipe(
      debounceTime(this.RELOAD_DEBOUNCE_TIME)
    ).subscribe( _ => this.loadGroups());
    
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
        this.loadGroups();
      }
    });    
  }
  
  loadGroups(){
    this.loading = true;
    const getParams: GetGroups$Params = { venueId: this.venueId, isRemoved: false, searchTerm: this.searchTerm };
    this.groupService.getGroups(getParams).subscribe(response => {
      this.groups = response.groups ? response.groups : [];
      this.loading = false;
    });
  }

  addNewGroup(){
    this.router.navigate([this.venueId, 'groups', 'new-group'])

  }

  editGroup(group: GroupDto){
    this.router.navigate([this.venueId, 'groups', 'new-group', group.id])
  }

  deleteGroup(group: GroupDto){
    this.confirmationService.confirm({
      header: this.translate.instant('GROUPS.DELETE_GROUP_TITLE'),
      message: this.translate.instant('GROUPS.DELETE_GROUP_TEXT'),
      acceptLabel: this.translate.instant('YES'),
      rejectLabel: this.translate.instant('NO'),
      defaultFocus: "reject",
      acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn destructive-btn',
      rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
      accept: () => {
        if(group.id){
          const params: RemoveGroup$Params = { servingAreaId: group.id }
          this.groupService.removeGroup(params).subscribe({
            next: response => this.loadGroups()
          })
        }
        
      }
    });

  }
  searchTermChange(): void {
    this.loading = true;
    this.searchDebouncer.next();
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
